import script from "./login.vue?vue&type=script&lang=ts&setup=true"
export * from "./login.vue?vue&type=script&lang=ts&setup=true"

import "./index.scss?vue&type=style&index=0&id=0fdfb676&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fdfb676"]])

export default __exports__